import { render, staticRenderFns } from "./RetrievePassword.vue?vue&type=template&id=09db5b81&scoped=true"
import script from "./RetrievePassword.vue?vue&type=script&lang=js"
export * from "./RetrievePassword.vue?vue&type=script&lang=js"
import style0 from "./RetrievePassword.vue?vue&type=style&index=0&id=09db5b81&prod&lang=scss"
import style1 from "./RetrievePassword.vue?vue&type=style&index=1&id=09db5b81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09db5b81",
  null
  
)

export default component.exports